<template>
  <div class="sino-tabs">
    <el-tabs v-model="active" @tab-click="handleClick">
      <slot>
        <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
      </slot>
    </el-tabs>
    <!-- 按钮组 -->
    <div class="right-btn">
      <slot name="tabsBtn"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "sino-tabs",
  props: {
    active: {
      type: String,
      default: "first",
    },
  },
  data() {
    return {};
  },
  created() {
    this.$nextTick(() => {
      let dom = document.getElementsByClassName("el-tabs__header");
      let btnDom = document.getElementsByClassName("right-btn");
      dom[0].appendChild(btnDom[0]);
    });
  },
  methods: {
    handleClick(tab, event) {
      this.$emit("tab-click", tab, event);
    },
  },
};
</script>
<style scoped lang="scss">
.sino-tabs {
  /deep/.el-tabs__header {
    display: flex;
    align-items: center;
    /* align-items: flex-end; */
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 100%;
      height: 2px;
      // background-color: #e4e7ed;
      background-color: transparent !important;
      z-index: 1;
    }
  }
  /deep/ .el-tabs__active-bar {
    width: 15px !important;
    height: 4px;
    border-radius: 2px;
    box-shadow: 0px 3px 8px 0px $tab_line_shadow;
  }
  /deep/.el-tabs__nav-wrap {
    flex: 1;
    flex-grow: 1;
    &::after {
      height: 0;
    }
  }
  /deep/.el-tabs__item {
    box-shadow: none !important;
    font-size: 16px;
    color: $primaryTextColor;
    opacity: 0.6;
    font-weight: 500;

    &:hover,
    &.is-active {
      color: $primaryTextColor;
      opacity: 1;
    }

    &.is-active {
      font-weight: 600;
      // opacity: 1;
    }
  }
}
</style>